// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { CardCarouselCardFragmentDoc } from './CardCarouselCard.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../imageSize.fragment.generated';
export const ComponentCardCarouselFragmentDoc = `
    fragment componentCardCarousel on ComponentCardCarousel {
  items {
    ...cardCarouselCard
  }
}
    `;